export default {
    common_loading: '正在加载',
    common_cancel: '取消',
    common_confirm: '确认',
    common_continue: '继续',
    common_submit: '提交',
    common_token_expire: 'token已过期，请重新登录。',
    common_modify_success: '修改成功',
    common_success: '成功',

    common_home: '首页',
    common_market: '市场',
    common_msgs: '消息',
    common_find: '查找',
    common_me: '我',

    common_deposit: '存款',
    common_withdraw: '提现',
    common_team: '团队',
    common_channel: '频道',
    common_service: '服务',
    common_currency: '货币',
    common_more: '更多',
    common_detail: '详细信息',
    common_search: '搜索',
    common_language: '语言',
    common_share: '分享',
    common_logout: '退出',
    common_copy_success: '复制成功',
    common_send: '发送',
    common_empty_data: '无数据',
    common_created: '创建',
    common_time: '时间',
    common_download_app: '下载APP',
    common_download: '下载',

    toast_input_phone: '请输入手机号',
    toast_input_password: '请输入密码',
    toast_input_full_name: '请输入全名',
    toast_input_email: '请输入邮箱',
    toast_input_refcode: '请输入参考码',
    toast_input_old_password: '请输入旧密码',
    toast_input_new_password: '请输入新密码',
    toast_input_repeat_password: '请输入重复密码',
    toast_input_repeat_password_nosame: '两次密码不同',
    toast_input_phone_length: '手机号不能小于10位',

    login_welcome: '欢迎回来！',
    login_subtitle: '登录您的账户',
    login_no_account: '没有账户？',
    register_title: '创建账户',
    register_subtitle: '让我们开始一个免费的量化交易账户',
    register_have_account: '已经有账户了？',
    user_phone: '手机号码',
    user_password: '密码',
    user_forget_password: '忘记密码？',
    user_sign_in: '登录',
    user_sign_up: '注册up',
    user_full_name: '全名',
    user_email: '电子邮件',
    user_verife_code: '验证码',
    user_ref_code: '邀请码',
    user_old_password: '旧密码',
    user_new_password: '新密码',
    user_repeat_password: '重复密码',
    user_find_password: '查找我的密码',
    user_modify_password: '修改我的密码',
    user_modify_login_password: '修改登录密码',
    user_account_security: '帐户安全',

    user_center: '用户中心',
    user_invite_reward_title: '获得至少 10% 的奖金',
    user_invite_reward_desc: '邀请朋友加入可获得不限数量的奖金',
    user_invite_records: '邀请奖励记录',
    user_security_protect: '保护账户安全',

    user_kefu_title1: '联系我们',
    user_kefu_title2: '方法如下',
    user_kefu_24hour_hint: '24小时在线客服',
    user_kefu_notice: '当被邀请用户充值时，奖励将自动添加到您的账户余额中',
    user_invited: 'invited',

    share_hint: '当被邀请用户充值时，奖励将自动添加到您的账户余额中',
    share_copy_link: '复制链接并分享',
    share_rewards_record: '奖励记录',
    home_total_asset_value: '资产总值',
    msg_msgs: '消息',
    msg_contacts: '联系人',
    wallet_balance: '余额',
    wallet_salary_balance: '工资余额',
    wallet_update_bank: '更新提款银行',
    wallet_account_settlement: '账户结算',
    wallet_payroll_records: '工资记录',
    wallet_financial_records: '财务记录',
    wallet_trade_history: '交易历史',
    wallet_update_bank_info: '更新银行信息',
    wallet_update_bank_hint: '同一个账户只能绑定一个账户',
    wallet_update_bank_input_name: '请输入姓名',
    wallet_update_bank_input_cardno: '请输入卡号',
    wallet_update_bank_input_ifsc: '请输入 ifsc',
    wallet_update_bank_input_bankname: '请输入银行名称',
    wallet_update_bank_input_otp: '请输入分行 otp',
    wallet_bind_bank_message: '还没有绑定银行卡，是否现在去绑定',
    wallet_bind_bank_go: '去绑定',

    deposit_recommend_amount: '推荐金额',
    deposit_select_channel_title: '请选择充值渠道',
    withdraw_available_balance: '可用余额',
    withdraw_amount: '金额',
    withdraw_taxs: '税费',
    withdraw_total_amount: '总金额',
    withdraw_select_bank: '选择银行',
    withdraw_notice: '提现手续费20%税费，提现时间为周一至周五上午7点至9点，2，工资提现时间为周一至周日上午7点至9点',
    withdraw_password_modify_title: '修改取款密码',
    withdraw_set_paypassword_message: '还没有设置取款密码，是否现在去设置？',
    withdraw_pay_password_input: '请输入取款密码',

    trade_ordering: '交易中',
    trade_history: '历史',

    chat_message_deleted: '此消息已被删除',
    chat_message_empty: "暂无消息",
    chat_conversation_started: '聊天开始于：',
    chat_type_message: '输入消息',
    chat_reply: '回复',

    channel_signal: '信号频道',

    team_level_1: 'Level-1',
    team_level_2: 'Level-2',
    team_level_3: 'Level-3',
    team_reg_num: 'Total number of registered',
    team_recharge_num: 'Total number of rechargers',
    team_recharged: 'Recharged',
    team_unrecharge: 'Not recharged',

    user_remember_password: '记住密码',
    common_trade: '交易',
    common_time: '时间',
    currency_name: '名称',
    currency_latest_price: '最新价格',
    currency_rise_and_fall: '涨跌',
    trade_high_today: '今日高点',
    trade_low_today: '今日低点',
    trade_direction: '方向',
    trade_buy_more: "买涨",
    trade_buy_less: "买跌",
    time_min: '分钟',
    time_hour: '小时',
    time_day: '天',
    time_week: '周',
    time_mon: '周一',

    follow_order_title: '跟随顶级交易员，赚取收益',
    follow_order_desc: '您可以复制优秀交易员的策略，自动跟随下单，赚取收益',
    common_now_try: '立即体验',

    welfare_activity_title: '最新福利活动',
    welfare_activity_desc: '请随时关注首页动态，了解我们最新活动政策！',
    appdownload:'下载',
    welfarecenter:'福利中心',
}